var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext, useEffect } from 'react';
import { Footer } from '@michelin/acid-components';
import { useLegalDocuments } from '../../hooks/useLegalDocuments';
import { LegalDocsContext } from '../../centralProviderContext/CentralProviderContext';
// eslint-disable-next-line no-redeclare
function CentralProviderFooter(props) {
    var getSalesForceTermsLink = useLegalDocuments().getSalesForceTermsLink;
    var legalContext = useContext(LegalDocsContext);
    useEffect(function () { return legalContext.showLegalDocs(props.showLegalInformation || false); }, []);
    return (React.createElement(Footer, __assign({}, props, { onLegalLinkClick: function (doc) { return window.open(getSalesForceTermsLink(doc), '_self'); } })));
}
export default CentralProviderFooter;
//# sourceMappingURL=CentralProviderFooter.js.map